"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AVATAR_ICON_SIZE = void 0;
var AVATAR_ICON_SIZE = exports.AVATAR_ICON_SIZE = {
  'extra small': 12,
  small: 16,
  regular: 24,
  medium: 16
};
//# sourceMappingURL=AvatarIconSize.constants.js.map